export function initCharacterCounters() {
  function autoResizeTextFields() {
    $('textarea.form-control').each(function() {
      this.setAttribute('style', 'height: auto; width: 100%;');
      this.style.height = (this.scrollHeight) + 'px';
      updateCharCounter($(this));
    });
  }

  function effectiveLength(str) {
    return (str || '').replace(/\n/g, '\r\n').length;
  }

  function truncateToMax(str, max) {
    let count = 0;
    let i = 0;
    const s = str || '';
    while (i < s.length) {
      const add = s[i] === '\n' ? 2 : 1;
      if (count + add > max) break;
      count += add;
      i += 1;
    }
    return s.slice(0, i);
  }

  function updateCharCounter($textarea) {
    const text = $textarea.val() || '';
    const currentLength = effectiveLength(text);
    const maxLength = parseInt($textarea.attr('maxlength') || 2000, 10);
    const $counter = $textarea.siblings('.char-counter');
    if ($counter.length) {
      $counter.text(currentLength + '/' + maxLength);
      if (currentLength >= maxLength * 0.9) {
        $counter.addClass('text-danger');
      } else {
        $counter.removeClass('text-danger');
      }
    }
  }

  function limitChars($textarea) {
    const maxLength = parseInt($textarea.attr('maxlength') || 2000, 10);
    const val = $textarea.val() || '';
    if (effectiveLength(val) > maxLength) {
      $textarea.val(truncateToMax(val, maxLength));
    }
  }

  autoResizeTextFields();

  $(document).on('input', 'textarea.form-control', function() {
    const $this = $(this);
    limitChars($this);
    updateCharCounter($this);
    this.style.height = 'auto';
    this.style.height = (this.scrollHeight) + 'px';
  });

  $(document).on('cocoon:after-insert', function(e, insertedItem) {
    $(insertedItem).find('textarea.form-control').each(function() {
      this.setAttribute('style', 'height: auto; width: 100%;');
      this.style.height = (this.scrollHeight) + 'px';
      updateCharCounter($(this));
    });
  });
}

